import { styled } from 'linaria/react';
import { css } from 'linaria';
import { breakpoints } from 'media';
import { LinkButton } from 'fronton-react';
import { LinkButtonProps } from 'fronton-react/button/link-button/types';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0;
`;

export const StyledLinkButton = styled(LinkButton)<LinkButtonProps & { isActive: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: var(--space-200);
	background-color: ${({ isActive }) =>
		isActive ? 'var(--background-secondary)' : 'transparent'};
	border-radius: var(--rounding-l);

	&:nth-child(n + 5) {
		padding-left: var(--space-400);
	}

	${breakpoints.only.mobile} {
		color: ${({ isActive }) => (isActive ? 'var(--text-secondary_opacity-6' : 'inherit')};
		background-color: transparent;
		pointer-events: ${({ isActive }) => (isActive ? 'none' : 'initial')};
		padding-inline: 0;
		&:nth-child(n + 5) {
			padding-left: var(--space-200);
		}
	}
`;

export const displayMobile = css`
	${breakpoints.from.tablet} {
		display: none;
	}
`;

export const title = css`
	margin: 0 0 var(--space-200) 0;
	color: var(--text-primary);
`;
